import { ActType } from '../type/activity';
/**
 * 基础活动类
 */
export class Activity {
    constructor() {
        /** 活动类型 */
        this.type = ActType.distribution;
        /** 活动信息 */
        this.actInfo = {
            actId: '',
            actIdEn: '',
            actState: undefined,
            userActState: undefined,
        };
    }
    /** 判断是否可以执行活动 */
    beforeExecAct() {
        return true;
    }
}
